import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader 
        speed={2} 
        viewBox="0 0 400 600"
    >
        <rect x="12" y="10" width="100" height="30" />
        <rect x="268" y="10" width="120" height="30" />
        <rect x="12" y="50" width="140" height="30" />
        <rect x="228" y="50" width="160" height="30" />
        <rect x="12" y="90" width="378" height="30" />
        <rect x="12" y="130" width="378" height="30" />
        <rect x="12" y="170" width="85" height="105" />
        <rect x="107" y="175" width="281" height="20" rx="10" />
        <rect x="107" y="213" width="281" height="20" rx="10" />
        <rect x="107" y="248" width="281" height="20" rx="10" />
        <rect x="12" y="285" width="85" height="105" />
        <rect x="107" y="290" width="281" height="20" rx="10" />
        <rect x="107" y="328" width="281" height="20" rx="10" />
        <rect x="107" y="363" width="281" height="20" rx="10" />
        <rect x="12" y="400" width="85" height="105" />
        <rect x="107" y="405" width="281" height="20" rx="10" />
        <rect x="107" y="443" width="281" height="20" rx="10" />
        <rect x="107" y="478" width="281" height="20" rx="10" />
        <rect x="12" y="515" width="378" height="30" />
        <rect x="12" y="555" width="378" height="30" />
    </ContentLoader>
}